import React, { FC, PropsWithChildren } from "react";
import Footer from "components/layout/footer";
import Header from "components/layout/header";

type FullLayoutProps = PropsWithChildren<unknown>;

const FullLayout: FC<FullLayoutProps> = ({ children }: FullLayoutProps) => {
  return (
    <div className="app app-layout-private">
      <Header />
      <div className="container app-content">{children}</div>
      <Footer />
    </div>
  );
};

export default FullLayout;
